export type SettingModelSettingType = (typeof SettingModelSettingType)[keyof typeof SettingModelSettingType];

export const SettingModelSettingType = {
    Panels: 'Panels',
    Connectors: 'Connectors',
    Corners: 'Corners',
    StopEnd: 'StopEnd',
    Anchors: 'Anchors'
} as const;
